/* eslint-disable no-prototype-builtins */
import { OPTION_HASH_VERSIONS } from '../interfaces/ItemTemplateOptions';
import _ from 'lodash';
import md5 from 'md5';
export const inventoryutils = {
    getOptionHash(data) {
        if (_.isNil(data.itemTemplate) || _.isNil(data.itemTemplate.objectId)) {
            throw 'WRONG itemTemplate';
        }
        const { itemTemplate: { objectId: templateId, hashVersion = OPTION_HASH_VERSIONS.V1, name: templateName, event }, packageId, options } = data;
        const entityId = (event === null || event === void 0 ? void 0 : event.objectId) || packageId;
        let templateLiteral = '';
        if (typeof entityId !== 'string') {
            throw 'type is WRONG';
        }
        if (hashVersion === OPTION_HASH_VERSIONS.V1) {
            templateLiteral = templateName;
        }
        else {
            templateLiteral = templateId;
        }
        if (!templateLiteral) {
            throw 'templateName is false!';
        }
        templateLiteral = inventoryutils.removeWhitespace(templateLiteral).toLowerCase();
        const tokens = [entityId, templateLiteral];
        const optionTokens = inventoryutils.getOptionTokensForHash(options);
        tokens.push(...optionTokens);
        return md5(tokens.join('')).toString();
    },
    getOptionTokensForHash(options) {
        const tokens = [];
        function addOptionTokens(option, parentToken = '') {
            if (!option.name || !option.value || !option.option_id) {
                console.error(option);
                throw 'hash will be invalid';
            }
            const name = inventoryutils.removeWhitespace(option.name).toLowerCase();
            const value = inventoryutils.removeWhitespace(option.value).toLowerCase();
            const token = parentToken + name + value + option.option_id;
            tokens.push(token);
            if (option.children && option.children.length) {
                inventoryutils.sortedForEach(option.children, (child) => {
                    addOptionTokens(child, token);
                });
            }
        }
        inventoryutils.sortedForEach(options, (option) => {
            addOptionTokens(option);
        });
        return tokens;
    },
    sortedForEach: function (options, step) {
        const sortedOptions = _.sortBy(options, function (option) { return option.name; });
        _.each(sortedOptions, function (option) {
            step(option);
        });
    },
    removeWhitespace: function (str) {
        return String(str).split(" ").map(Function.prototype.call, String.prototype.trim).join("");
    },
    /**
     * This function is used to build a nested structure of selected options
     *  from the flat list of selected options.
     * @param {IOptionSelection[]} selections
     * @param {IOption[]} itemTemplateOptions
     * @return {*}  {*}
     */
    buildNestedStructure(selections, itemTemplateOptions) {
        const getOptionDetails = (optionId, valueId, isCustomInput) => {
            const option = this.findOptionById(optionId, itemTemplateOptions);
            if (option) {
                const value = isCustomInput ? { value: valueId } : option.values.find((v) => v.id === valueId);
                return { name: option.name, value: value ? value.value : '', option_id: option.objectId, inputType: option.inputType };
            }
            return null;
        };
        const findChildren = (parentOptionId, parentValueId) => {
            return selections.filter((sel) => sel.parentId === parentOptionId && sel.parentValueId === parentValueId);
        };
        const buildTree = (optionId, valueId, isCustomInput) => {
            const details = getOptionDetails(optionId, valueId, isCustomInput);
            if (!details)
                return null;
            const children = findChildren(optionId, valueId).map((childSel) => buildTree(childSel.optionId, childSel.valueId, childSel.isCustomInput)).filter((child) => child !== null);
            if (children.length > 0) {
                details.children = children;
            }
            return details;
        };
        // Start building the tree from top-level selections
        return selections
            .filter((sel) => sel.parentId === null)
            .map((sel) => buildTree(sel.optionId, sel.valueId, sel.isCustomInput))
            .filter((tree) => tree !== null);
    },
    findOptionById(optionId, itemTemplateOptions) {
        const findOption = (options, id) => {
            for (const option of options) {
                if (option.objectId === id)
                    return option;
                if (option.children) {
                    const found = findOption(option.children, id);
                    if (found)
                        return found;
                }
            }
            return null;
        };
        return findOption(itemTemplateOptions, optionId);
    },
    resetSelectedOptionsForParentChange(itemTemplateOptions, selectedOption, linkedPackageMap) {
        function traverseAndReset(option) {
            if (option.objectId === selectedOption.id) {
                resetChildren(option);
            }
            else if (option.children) {
                option.children.forEach(child => traverseAndReset(child));
            }
        }
        function resetChildren(option) {
            if (option.children) {
                option.children.forEach(child => {
                    child.selected = null;
                    // added support to reset the selected options for the child package links
                    if (child.inputType === 'link') {
                        const linkedPackageKeyPrefix = `ItemOptionId_${child.objectId}_PackageId_`;
                        Object.keys(linkedPackageMap).forEach((key) => {
                            if (key.startsWith(linkedPackageKeyPrefix)) {
                                delete linkedPackageMap[key];
                            }
                        });
                    }
                    resetChildren(child);
                });
            }
        }
        itemTemplateOptions.forEach(option => traverseAndReset(option));
    },
    removeChildSelections(selections, selection) {
        const parentIdToRemove = selection.id;
        function removeNested(selections, parentId, parentValueId) {
            let updatedSelections = selections.filter(sel => sel.parentId !== parentId);
            const childrenToRemove = selections.filter(sel => sel.parentValueId === parentValueId);
            childrenToRemove.forEach(child => {
                updatedSelections = removeNested(updatedSelections, child.optionId, child.valueId);
            });
            return updatedSelections;
        }
        const parentSelection = selections.find(sel => sel.optionId === parentIdToRemove);
        if (parentSelection) {
            const parentValueIdToRemove = parentSelection.valueId;
            return removeNested(selections, parentIdToRemove, parentValueIdToRemove);
        }
        return selections;
    },
    updateSelections(selections, selection) {
        const index = selections.findIndex(sel => sel.optionId === selection.id);
        if (index !== -1) {
            selections[index].valueId = selection.value;
        }
        else {
            selections.push({
                optionId: selection.id, valueId: selection.value, isCustomInput: selection.isCustomInput,
                parentId: selection.parentId, parentValueId: selection.parentValueId
            });
        }
        if (!selection.noEmits) {
            selections = this.removeChildSelections(selections, selection);
        }
        return selections;
    },
    areAllOptionsSelected(options) {
        if (!options || options.length === 0)
            return true;
        return _.every(options, (option) => {
            if (option.value === '')
                return false;
            if (option.children) {
                const children = _.isArray(option.children) ? option.children : [option.children];
                return _.every(children, child => {
                    if (typeof child.value !== 'string' || !child.value)
                        return false;
                    if (child.children)
                        return inventoryutils.areAllOptionsSelected(child.children);
                    return true;
                });
            }
            return true;
        });
    },
    /**
     * This function is used to get the simplified object of the selected options
     * based on the selected options.
     *
     * @param {IOptionInventoryObject} obj
     * @return {*}
     */
    getSimplifiedObject(obj) {
        const { name, value, option_id, inputType, children } = obj;
        const simplifiedObject = { name, value, option_id, inputType };
        if (children && children.length > 0) {
            simplifiedObject.children = children.map(child => inventoryutils.getSimplifiedObject(child));
        }
        return simplifiedObject;
    },
    sanitizeSelectedOptions(selectedOptions) {
        return Object.values(selectedOptions).flatMap((option) => option).map(option => inventoryutils.getSimplifiedObject(option));
    },
    updateItemTemplateOptionsWithPreSelectedValues(itemTemplateOptions, preSelectedValues) {
        function findAndUpdateOption(option, selectedValue) {
            var _a;
            if (option.objectId === selectedValue.option_id || selectedValue.option.objectId) {
                const selectedOptionValue = selectedValue.optionValue || selectedValue.value;
                if (option.values) {
                    option.selected = option.values.find((value) => value.value === selectedOptionValue);
                    if ((_a = selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.itemInstance) === null || _a === void 0 ? void 0 : _a.objectId) {
                        option.itemInstance = selectedValue.itemInstance.objectId;
                    }
                }
                if (option.inputType === 'custom') {
                    option.selected = { value: selectedOptionValue };
                }
                if (selectedValue.children) {
                    selectedValue.children.forEach(childValue => {
                        var _a;
                        const childToUpdate = (_a = option.children) === null || _a === void 0 ? void 0 : _a.find((child) => child.objectId === childValue.option_id);
                        if (childToUpdate) {
                            findAndUpdateOption(childToUpdate, childValue);
                        }
                    });
                }
            }
        }
        preSelectedValues.forEach((selectedValue) => {
            const matchingOption = itemTemplateOptions.find(option => { var _a; return (option.objectId === ((_a = selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.option) === null || _a === void 0 ? void 0 : _a.objectId) || option.objectId === (selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.option_id)); });
            if (matchingOption) {
                findAndUpdateOption(matchingOption, selectedValue);
            }
        });
        return itemTemplateOptions;
    },
    compareNestedValues(original, updated) {
        if (original.value !== updated.value) {
            return false;
        }
        if (original.children && updated.children) {
            if (original.children.length !== updated.children.length) {
                return false;
            }
            for (let i = 0; i < original.children.length; i++) {
                if (!inventoryutils.compareNestedValues(original.children[i], updated.children[i])) {
                    return false;
                }
            }
        }
        else if ((!original.children && updated.children) || (original.children && !updated.children)) {
            return false;
        }
        return true;
    },
    /**
     * This function is used to update the changed values in the selected options
     * based on the original options and the changed options.
     *
     * @param {IOptionInventoryObject[]} changedOptions
     * @param {IItemInstanceOptionResponse[]} originalOptions
     * @return {*}
     */
    updateChangedValues(changedOptions, originalOptions) {
        const updatedItems = changedOptions.filter(newItem => {
            const originalOption = originalOptions.find(oldItem => oldItem.itemInstance.objectId === newItem.itemInstance &&
                oldItem.option.objectId === newItem.option_id &&
                oldItem.optionName === newItem.name);
            if (!originalOption) {
                return true;
            }
            const originalObject = {
                value: originalOption.optionValue,
                children: originalOption.children
            };
            const comparisonResult = !inventoryutils.compareNestedValues(originalObject, newItem);
            return comparisonResult;
        });
        return updatedItems;
    },
    /**
     * This function is used to validate the selection of options for an item
     * based on the item options and the selected options.
     *
     * @param {IOption[]} itemOptions
     * @param {IOptionInventoryObject[]} selections
     * @return {*}  {boolean}
     */
    validateSelection(itemOptions, selections) {
        var _a;
        const validateChildren = (optionChildren, selectionChildren, parentValue, parentValueId) => {
            var _a;
            const relevantChildren = optionChildren.filter(option => option.parentValueId === parentValueId && option.inputType !== 'link');
            if (parentValue === '') {
                return false;
            }
            if (relevantChildren.length !== selectionChildren.length) {
                return false;
            }
            if (selectionChildren.some(sel => sel.value === '')) {
                return false;
            }
            for (const option of relevantChildren) {
                const matchingSelection = selectionChildren.find(sel => sel.option_id === option.objectId);
                if (option.inputType === 'custom' || option.inputType === 'link')
                    continue;
                if (option.values.length === 0 && !matchingSelection)
                    continue;
                if (matchingSelection) {
                    const childValueId = (_a = option.values.find(val => val.value === matchingSelection.value)) === null || _a === void 0 ? void 0 : _a.id;
                    if (!validateChildren(option.children ? option.children : [], matchingSelection.children || [], matchingSelection.value, childValueId)) {
                        return false;
                    }
                }
                else {
                    return false;
                }
            }
            return true;
        };
        for (const itemOption of itemOptions) {
            const matchingSelection = selections.find(sel => sel.option_id === itemOption.objectId);
            if (itemOption.inputType === 'link')
                continue;
            if (!matchingSelection) {
                return false;
            }
            const parentValueId = (_a = itemOption.values.find(val => val.value === matchingSelection.value)) === null || _a === void 0 ? void 0 : _a.id;
            if (!validateChildren(itemOption.children ? itemOption.children : [], matchingSelection.children || [], matchingSelection.value, parentValueId)) {
                return false;
            }
        }
        return true;
    }
};
